import { render } from "./VuexMultiFileUploadFormItem.vue?vue&type=template&id=03e96d48"
import script from "./VuexMultiFileUploadFormItem.vue?vue&type=script&lang=js"
export * from "./VuexMultiFileUploadFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__